import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const API_URL = `${API_BASE_URL}/competiciones`;

// Función para obtener las competiciones
export const getCompeticionesByTemporada = async (idTemporada, navigate) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}/${idTemporada}`,
      {
        method: "GET",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener las competiciones");
  } catch (error) {
    throw error;
  }
};


// Función para obtener las competiciones
export const getCompeticionByIdTemporadaAndId = async (
  idTemporada,
  idCompeticion,
  navigate
) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}/${idTemporada}/${idCompeticion}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener la competicion");
  } catch (error) {
    throw error;
  }
};
